const InlineLoader = ({ small = false }) => {
    if (small) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', padding: '8px 0' }}>
                <span className="spinner-border spinner-border-sm text-primary" />
            </div>
        );
    }

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '40px 0' }}>
            <span className="spinner-border text-primary" />
        </div>
    );
};

export default InlineLoader;
